
angular.module('dybAuthentication', ['classy'])
